import React from "react";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { MoralisProvider } from "react-moralis";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./Routes";
import { Provider } from "react-redux";
import store from "./store/index";

const moralisCreds = {
  appId: "TXtVu1q1p7XzCG976MImOAuzj2dpkjZzADIhKi81",
  serverUrl: "https://adw3aaombzve.usemoralis.com:2053/server",
};

const theme = extendTheme({
  colors: {
    brand: {
      100: "#CCD3FF",
      200: "#B2BDFF",
      300: "#99A7FF",
      400: "#7F91FF",
      500: "#667BFF",
      600: "#4C65FF",
      700: "#334FFF",
      800: "#1939FF",
      900: "#0023FF",
    },
  },
});

const App = () => {
  return (
    <>
      <Provider store={store}>
        <ChakraProvider theme={theme}>
          <MoralisProvider {...moralisCreds}>
            <Router>
              <AppRoutes />
            </Router>
          </MoralisProvider>
        </ChakraProvider>
      </Provider>
    </>
  );
};

export default App;
